var _path, _path2, _path3, _rect, _ellipse, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 155,
    viewBox: "0 0 314 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M281.282 88.8749C299.305 88.8749 313.916 103.486 313.916 121.509C313.916 139.532 299.305 154.143 281.282 154.143C263.259 154.143 248.648 139.532 248.648 121.509C248.648 103.486 263.259 88.8749 281.282 88.8749Z",
    fill: "#009688"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3839 0.386353C51.407 0.386353 66.0177 14.997 66.0177 33.0202C66.0177 51.0434 51.407 65.6541 33.3839 65.6541C15.3607 65.6541 0.75 51.0434 0.75 33.0202C0.75 14.997 15.3607 0.386353 33.3839 0.386353Z",
    fill: "#FCCE30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M281.282 0.386353C299.305 0.386353 313.916 14.997 313.916 33.0202C313.916 51.0434 299.305 65.6541 281.282 65.6541C263.259 65.6541 248.648 51.0434 248.648 33.0202C248.648 14.997 263.259 0.386353 281.282 0.386353Z",
    fill: "#E25F16"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30.0264,
    y: 154.143,
    width: 65.065,
    height: 174.374,
    transform: "rotate(-90 30.0264 154.143)",
    fill: "#2D70FD"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.328,
    cy: 121.61,
    rx: 32.5325,
    ry: 32.6073,
    transform: "rotate(-90 204.328 121.61)",
    fill: "#2D70FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3839 88.8749C29.0983 88.8749 24.8547 89.719 20.8954 91.359C16.9361 92.999 13.3386 95.4028 10.3082 98.4331C7.2779 101.463 4.87411 105.061 3.2341 109.02C1.5941 112.98 0.75 117.223 0.75 121.509C0.75 125.794 1.5941 130.038 3.2341 133.997C4.87411 137.956 7.2779 141.554 10.3082 144.584C13.3386 147.615 16.9361 150.018 20.8954 151.658C24.8547 153.298 29.0983 154.143 33.3839 154.143L33.3839 121.509V88.8749Z",
    fill: "#2D70FD"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.559 0.386353C103.273 0.386353 99.0295 1.23045 95.0702 2.87046C91.1109 4.51046 87.5134 6.91425 84.483 9.94459C81.4527 12.9749 79.0489 16.5724 77.4089 20.5318C75.7689 24.4911 74.9248 28.7347 74.9248 33.0202C74.9248 37.3057 75.7689 41.5493 77.4089 45.5086C79.0489 49.468 81.4527 53.0655 84.483 56.0958C87.5134 59.1262 91.1109 61.5299 95.0702 63.1699C99.0295 64.81 103.273 65.6541 107.559 65.6541L107.559 33.0202V0.386353Z",
    fill: "#E2164B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.502 0.588989L105.502 65.654L205.052 65.654V65.652C222.689 65.4745 236.931 50.9779 236.931 33.1212C236.931 15.2644 222.689 0.76786 205.052 0.590317V0.588989H204.869C204.821 0.588776 204.772 0.588669 204.724 0.588669C204.676 0.588669 204.628 0.588776 204.58 0.588989L105.502 0.588989Z",
    fill: "#E2164B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c549b22984076cb04644dd0289f6d141.svg";
export { ForwardRef as ReactComponent };